<template>
  <div>
    <v-toolbar dark prominent>
      <v-app-bar-nav-icon>
        <v-icon color="blue darken-2" @click="backButton">
          mdi-arrow-left
        </v-icon>
      </v-app-bar-nav-icon>
      <!-- <v-spacer></v-spacer> -->

      <v-col cols="10" md="12" sm="10">
        <v-img
          src="/img/fantasy_lineups_logo.png"
          class="logo mx-auto"
          max-width="350"
          contain
        />
      </v-col>
    </v-toolbar>

    <!-- content -->
    <h3 class="text-center text-h5 pa-3 text-decoration-underline">
      Server Settings
    </h3>
    <v-row justify="center" class="mt-2">
      <v-data-table
        :headers="Headers"
        :items="serverFilter"
        :items-per-page="10"
        class="elevation-1"
        hide-default-footer
        mobile-breakpoint="0"
      >
        <template v-slot:item.name="{ item }">
          <p>{{ item.name | upperCase }}</p>
        </template>

        <template v-slot:item.pm2_env.status="{ item }">
          <p>{{ item.pm2_env.status | upperCase }}</p>
        </template>

        <template v-slot:item.actions="{ item }">
          <div class="pt-5">
            <v-select
              dense
              :items="items"
              label="Select Action"
              @change="updateServerStatus(item)"
              outlined
            ></v-select>
          </div>
        </template>
      </v-data-table>
    </v-row>
  </div>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
export default {
  name: "settings",
  filters: {
    upperCase(value) {
      return value.toUpperCase();
    },
  },

  data() {
    return {
      items: ["Start", "Stop"],
      Headers: [
        { text: "Name", value: "name" },

        { text: "Status", value: "pm2_env.status" },
        { text: "Action", value: "actions", sortable: false },
      ],
    };
  },

  created() {
    this.$store.dispatch("NbaModule/getProcessInfo");
  },

  beforeRouteEnter(to, from, next) {
    if (localStorage.getItem("role") !== "client") {
      next({ name: "Pricing" });
    } else {
      next();
    }
  },

  methods: {
    backButton() {
      this.$router.go(-1);
    },

    updateServerStatus(process) {
      // debugger;
      if (process.pm2_env.status == "online") {
        let obj = {
          name: process.name,
          operation: "stop",
        };
        axios
          .post("https://api.fantasylineups.com/user/UpdateServer", obj)
          .then(() => {
            process.pm2_env.status = "stopped";
          });
      } else {
        let obj = {
          name: process.name,
          operation: "start",
        };
        axios
          .post("https://api.fantasylineups.com/user/UpdateServer", obj)
          .then(() => {
            process.pm2_env.status = "online";
          });
      }
    },
  },
  computed: {
    ...mapState("NbaModule", ["processInfo"]),
    serverFilter() {
      let newArr = this.processInfo.filter((list) => {
        return list.name !== "server";
      });
      return newArr;
    },
  },
};
</script>

<style></style>
